import type { IChatAccess, IMessage, IStickerPack } from '@dev-fast/types';
import { stickers } from '@dev-fast/types';

export type ChatRoomId = 'shared' | 'ru' | 'en';

export interface ChatStateModel {
  items: IMessage[];
  stickers: IStickerPack[];
  chatAccess: IChatAccess;
  activeStickerPack: IStickerPack;
  chatId: ChatRoomId;
  isAnimationPlayed: boolean;
}

export const CHAT_INITIAL_STATE: ChatStateModel = {
  items: [],
  chatId: 'shared',
  activeStickerPack: stickers[0],
  stickers: stickers,
  chatAccess: { hasAccess: true },
  isAnimationPlayed: false,
};
